import React, { Component, Children } from 'react'
import Height from 'react-height'
import { Motion, spring } from 'react-motion'
import classNames from 'classnames'

export default class DropdownMenu extends Component {
  state = {
    height: 0,
    isOpen: false,
    isTransitioning: false
  }
  mounted = true

  componentWillMount() {
    this.singleChild = Children.count(this.props.children) == 1
  }

  componentDidMount() {
    document.addEventListener("click", this.handleDocumentClick, false)
  }

  componentWillUnmount() {
    this.mounted = false
    document.removeEventListener("click", this.handleDocumentClick, false)
  }

  handleDocumentClick = (event) => {
    if (this.mounted) {
      if (!this.node.contains(event.target)) {
        this.setState({
          isOpen: false
        })
      }
    }
  }

  handleMouseClick = (event) => {
    event.stopPropagation()
    event.preventDefault()

    this.setState({
      isOpen: !this.state.isOpen,
      isTransitioning: true
    })
  }

  handleRest = () => this.setState({ isTransitioning: false })

  onHeightReady = height => this.setState({ height })

  getMenuHeight = () => spring(this.state.isOpen ? this.state.height : 0, { stiffness: 200, damping: 20 })

  _renderSingleChild() {
    return (
      <Motion defaultStyle={{height: 0}} style={{height: this.getMenuHeight()}} onRest={this.handleRest}>
        {({height}) => (<div style={{height}} className="items"><Height onHeightReady={this.onHeightReady}>{this.props.children}</Height></div>)}
      </Motion>
    )
  }

  _renderMultipleChildren() {
    return <ul className="items">{Children.map(this.props.children, child => {return <li>{child}</li>})}</ul>
  }

  render() {
    const { menuClass, menuTitle } = this.props
    const { isOpen, isTransitioning } = this.state
    const className = classNames('dropdown', menuClass, { open: isOpen || (this.singleChild && isTransitioning) })

    return (
      <div className={className} onClick={this.handleMouseClick} ref={node => this.node = node}>
        <div className="title">{menuTitle}</div>
        {this.singleChild ? this._renderSingleChild() : this._renderMultipleChildren()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/navigation/DropdownMenu.js